/** @jsxImportSource @emotion/react */
import { useTheme } from "@emotion/react";
import React from "react";
import CommonNavigationBar from "components/MainComponents/NavigationBar/CommonNavigationBar";
import SuccessLogout from "components/MainComponents/Logout/LogoutSuccess";

export default function SuccessLogoutPage() {
  const theme = useTheme();

  return (
    <>
      <div>
        <CommonNavigationBar />
        <SuccessLogout />
      </div>
    </>
  );
}
